var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1914_4044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 4.77431V21.6C20.9999 22.9255 19.9254 24 18.5999 24H5.4C4.07452 24 3 22.9255 3 21.6V2.4C3 1.07452 4.07452 0 5.4 0H15.802L20.9999 4.77431Z",
    fill: "url(#paint0_linear_1914_4044)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1914_4044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 4.77431H16.4018C16.0704 4.77431 15.8018 4.50568 15.8018 4.17431V0L20.9996 4.77431Z",
    fill: "#E0EAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.67978 19.3994V14.4994H6.31778C6.88711 14.4994 7.35611 14.6021 7.72478 14.8074C8.09811 15.0081 8.37344 15.2927 8.55078 15.6614C8.73278 16.0254 8.82378 16.4547 8.82378 16.9494C8.82378 17.4441 8.73278 17.8757 8.55078 18.2444C8.37344 18.6084 8.10044 18.8931 7.73178 19.0984C7.36311 19.2991 6.89178 19.3994 6.31778 19.3994H4.67978ZM5.62478 18.5874H6.26878C6.67011 18.5874 6.98511 18.5221 7.21378 18.3914C7.44711 18.2607 7.61278 18.0741 7.71078 17.8314C7.80878 17.5841 7.85778 17.2901 7.85778 16.9494C7.85778 16.6041 7.80878 16.3101 7.71078 16.0674C7.61278 15.8201 7.44711 15.6311 7.21378 15.5004C6.98511 15.3697 6.67011 15.3044 6.26878 15.3044H5.62478V18.5874ZM11.89 19.4834C11.414 19.4834 10.994 19.3761 10.63 19.1614C10.266 18.9467 9.98133 18.6504 9.776 18.2724C9.57066 17.8897 9.468 17.4487 9.468 16.9494C9.468 16.4501 9.57066 16.0114 9.776 15.6334C9.98133 15.2507 10.266 14.9521 10.63 14.7374C10.994 14.5227 11.414 14.4154 11.89 14.4154C12.3707 14.4154 12.793 14.5227 13.157 14.7374C13.521 14.9521 13.8033 15.2507 14.004 15.6334C14.2093 16.0114 14.312 16.4501 14.312 16.9494C14.312 17.4487 14.2093 17.8897 14.004 18.2724C13.8033 18.6504 13.521 18.9467 13.157 19.1614C12.793 19.3761 12.3707 19.4834 11.89 19.4834ZM11.89 18.6364C12.1887 18.6364 12.4453 18.5687 12.66 18.4334C12.8793 18.2934 13.0497 18.0974 13.171 17.8454C13.2923 17.5934 13.353 17.2947 13.353 16.9494C13.353 16.5994 13.2923 16.3007 13.171 16.0534C13.0497 15.8014 12.8793 15.6077 12.66 15.4724C12.4453 15.3371 12.1887 15.2694 11.89 15.2694C11.596 15.2694 11.3393 15.3371 11.12 15.4724C10.9007 15.6077 10.7303 15.8014 10.609 16.0534C10.4877 16.3007 10.427 16.5994 10.427 16.9494C10.427 17.2947 10.4877 17.5934 10.609 17.8454C10.7303 18.0974 10.9007 18.2934 11.12 18.4334C11.3393 18.5687 11.596 18.6364 11.89 18.6364ZM17.3163 19.4834C16.8263 19.4834 16.4039 19.3784 16.0493 19.1684C15.6993 18.9537 15.4286 18.6574 15.2373 18.2794C15.0506 17.8967 14.9573 17.4557 14.9573 16.9564C14.9573 16.4571 15.0506 16.0161 15.2373 15.6334C15.4286 15.2507 15.6993 14.9521 16.0493 14.7374C16.4039 14.5227 16.8263 14.4154 17.3163 14.4154C17.9089 14.4154 18.3943 14.5624 18.7723 14.8564C19.1503 15.1504 19.3859 15.5657 19.4793 16.1024H18.4503C18.3896 15.8411 18.2613 15.6381 18.0653 15.4934C17.8739 15.3441 17.6219 15.2694 17.3093 15.2694C17.0199 15.2694 16.7703 15.3394 16.5603 15.4794C16.3549 15.6147 16.1963 15.8084 16.0843 16.0604C15.9723 16.3077 15.9163 16.6064 15.9163 16.9564C15.9163 17.3017 15.9723 17.6004 16.0843 17.8524C16.1963 18.1044 16.3549 18.2981 16.5603 18.4334C16.7703 18.5687 17.0199 18.6364 17.3093 18.6364C17.6219 18.6364 17.8739 18.5687 18.0653 18.4334C18.2566 18.2934 18.3826 18.0997 18.4433 17.8524H19.4793C19.3859 18.3611 19.1503 18.7601 18.7723 19.0494C18.3943 19.3387 17.9089 19.4834 17.3163 19.4834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1914_4044",
    x: 14.0018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1914_4044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1914_4044",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1914_4044",
    x1: 18,
    y1: 2.5,
    x2: 2.5,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1914_4044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.d856b574509419e45e9bfff41df766d2.svg";
export { ForwardRef as ReactComponent };